export default {
  title: 'Gateway di pagamento',
  description:
    "I tuoi gateway di pagamento per gli ordini online. L'intero importo dell'ordine viene liquidato sul tuo conto gateway; sei tu a regolare i conti con i tuoi ristoranti.",
  toasts: {
    load_error: 'Impossibile caricare la configurazione del gateway',
  },
  not_enabled: {
    title: 'Spreedly non è ancora abilitato per il tuo account',
    description:
      'I gateway di pagamento locali vengono attivati da FoodAmigos. Contatta il tuo referente FoodAmigos per iniziare.',
  },
  processor_mode: {
    title: 'Chi elabora i pagamenti?',
    description:
      'Impostato una sola volta per tutti i tuoi ristoranti. Puoi cambiarlo in seguito nelle Impostazioni partner finché nessun ristorante è attivo.',
    save: 'Salva',
    options: {
      platform: {
        title: 'FoodAmigos elabora i pagamenti',
        badge: 'Consigliato',
        description:
          'Gestiamo il conto pagamenti, la verifica e i pagamenti. Ogni ristorante aggiunge i dati aziendali e completa una breve verifica con Adyen.',
        methods: 'Accettati: {{methods}}',
      },
      provider: {
        title: 'Uso un mio provider',
        description:
          'Collega un provider di pagamento che già usi. Pagamenti, commissioni e verifica restano con loro.',
      },
    },
    payment_methods: {
      card: 'Carta',
      apple_pay: 'Apple Pay',
      google_pay: 'Google Pay',
      pay_by_bank: 'Pagamento tramite banca',
      giropay: 'giropay',
      sepa_debit: 'SEPA',
    },
    locked: {
      platform: 'FoodAmigos elabora i pagamenti per tutti i tuoi ristoranti.',
      provider: 'I tuoi ristoranti accettano pagamenti tramite i tuoi provider.',
    },
    confirm_choice: {
      title: 'Impostare i pagamenti su “{{mode}}”?',
      description:
        'Si applica a tutti i ristoranti che gestisci. Puoi cambiare in seguito dalle Impostazioni partner, ma solo finché nessun ristorante è attivo.',
      confirm: 'Salva e continua',
    },
    switch: {
      link: 'Cambia come vengono elaborati i pagamenti',
      confirm: {
        confirm: 'Cambia',
        provider: {
          title: 'Passare al tuo provider?',
          description: 'I ristoranti che usano i pagamenti FoodAmigos torneranno a Non configurato.',
        },
        platform: {
          title: 'Passare ai pagamenti FoodAmigos?',
          description: 'I ristoranti che usano i tuoi provider torneranno a Non configurato.',
        },
      },
      unavailable: {
        title: 'I pagamenti FoodAmigos non sono ancora disponibili',
        description: 'I pagamenti FoodAmigos non sono ancora disponibili nel tuo Paese.',
        confirm: 'OK',
      },
      blocked: {
        title: 'Contatta FoodAmigos per modificarlo',
        description_one:
          "{{count}} ristorante sta ricevendo pagamenti live. Il passaggio significherebbe dover effettuare nuovamente l'onboarding con il nuovo provider. Il nostro team lo pianificherà con te.",
        description_other:
          '{{count}} ristoranti stanno ricevendo pagamenti in tempo reale. Cambiare significherebbe farli riaccreditare con il nuovo provider. Il nostro team lo pianificherà con te.',
        confirm: 'Invia email a FoodAmigos',
        subject_one: 'Modifica la modalità di elaborazione dei pagamenti ({{count}} ristorante live)',
        subject_other: 'Cambio elaborazione pagamenti ({{count}} ristoranti attivi)',
      },
    },
    toasts: {
      load_error: 'Impossibile caricare la configurazione dei pagamenti',
      save_error: 'Impossibile salvare la configurazione dei pagamenti',
      chosen: 'Elaborazione pagamenti salvata',
      switched: 'Elaborazione pagamenti cambiata',
    },
  },
  gateways: {
    title: 'Fornitori collegati',
    empty: 'Collega il fornitore di pagamento che già usi. I tuoi ristoranti saranno attivati sotto di esso.',
    connect_another: 'Collega un fornitore',
    support_hint:
      'Una volta che un ristorante accetta pagamenti live, cambiare il suo fornitore va pianificato con noi — scrivi a {{email}}.',
    kinds: {
      stripe_connect: 'Stripe Connect',
      spreedly: 'Gateway di pagamento',
      platform_adyen: 'Pagamenti FoodAmigos',
    },
    statuses: {
      connected: 'Collegato',
      disconnected: 'Non collegato',
      needs_attention: 'Richiede attenzione',
    },
    issue: {
      connect_not_enabled: {
        title: "Stripe Connect non è abilitato sull'account associato a {{name}}",
        description:
          'Stripe non può creare account per i tuoi ristoranti finché Connect non è abilitato. Abilitalo nella tua Dashboard Stripe, poi ricontrolla qui.',
      },
      account_restricted: {
        title: 'Stripe sta bloccando i nuovi account sotto {{name}}',
        description:
          'Stripe ha limitato temporaneamente il tuo account nella creazione di account collegati. Accedi alla tua Dashboard Stripe, conferma di aver voluto creare questi account, poi ricontrolla qui.',
      },
      loss_liability_unaccepted: {
        title: 'Stripe richiede che {{name}} accetti prima la responsabilità per le perdite',
        description:
          'La tua piattaforma Stripe non ha ancora accettato la responsabilità per i saldi negativi sugli account dei tuoi ristoranti, quindi Stripe non li creerà. Nella tua Dashboard Stripe, apri Impostazioni → Connect → Profilo della piattaforma e completa la conferma della responsabilità per le perdite, poi controlla di nuovo qui. Puoi ignorare la nota di Stripe sugli Account v2 qui sotto.',
      },
      account_creation_refused: {
        title: 'Stripe ha rifiutato di creare un account ristorante sotto {{name}}',
        description: 'Controlla il messaggio qui sotto nella tua Dashboard Stripe, poi ricontrolla qui.',
      },
      key_invalid: {
        title: 'Stripe non accetta più la chiave collegata per {{name}}',
        description:
          'La chiave è stata sostituita, revocata o è scaduta. Crea una nuova chiave nella tua Stripe Dashboard, poi sostituiscila qui.',
      },
      key_access_limited: {
        title: 'Stripe ha limitato la chiave che hai collegato per {{name}}',
        description:
          "Una chiave limitata non può creare trasferimenti o pagamenti per i tuoi ristoranti. Nella Dashboard di Stripe, apri Sviluppatori → Chiavi API e ripristina l'accesso completo della chiave, poi ricontrolla qui — oppure ruota la chiave e sostituiscila qui.",
      },
      provider_said: 'Cosa ha detto Stripe: «{{message}}»',
      hint: 'Finché il problema non sarà risolto, i ristoranti collegati a questo provider non potranno iniziare ad accettare pagamenti online.',
      open_stripe: 'Apri Dashboard Stripe',
      check_again: 'Ricontrolla',
      replace_key: 'Sostituisci chiave',
      cleared: 'Stripe ha accettato di nuovo i tuoi ristoranti',
      still_blocked: 'Stripe continua a rifiutare — vedi cosa ha detto sopra',
    },
    refused: {
      provider_said: 'Cosa ha detto {{name}}: «{{message}}»',
      reference: 'Riferimento:',
      contact_support: 'Contatta il supporto via email',
      support_subject: 'Connessione al fornitore di pagamento rifiutata: {{name}} (rif {{reference}})',
      account_in_test_mode: {
        action: 'Disattiva la Modalità di Test in Authorize.Net, in {{path}}, poi riprova.',
        open: 'Apri Authorize.Net',
      },
      processor_not_configured: {
        action:
          "Contatta il tuo fornitore di servizi per operatori, l'azienda che ha aperto il tuo account Authorize.Net, e chiedi loro di completarne la configurazione con il suo processore di pagamento. Le nuove chiavi non risolveranno il problema. Poi riprova.",
        action_card_connect:
          'Chiedi al supporto di CardConnect di abilitare le autorizzazioni card-not-present (e-commerce) su questo ID esercente. Nuove credenziali API non cambieranno la situazione. Poi riprova.',
      },
    },
    table: {
      primary_tag: 'Predefinito',
      live_count_one: '{{count}} attivi per i pagamenti',
      live_count_other: '{{count}} attivi per i pagamenti',
      attention_count_one: '{{count}} richiede attenzione',
      attention_count_other: '{{count}} richiedono attenzione',
      columns: {
        connection: 'Fornitore',
        status: 'Stato',
        restaurants: 'Ristoranti',
        methods: 'Metodi locali',
      },
      methods_count: '{{enabled}} di {{capable}} attivi',
    },
    picker: {
      recommended: 'Consigliato',
      connect: 'Collega',
      stripe_connect: {
        title: 'Stripe Connect',
        description:
          "Usa il tuo account Stripe. Ogni ristorante completa l'onboarding di Stripe; payout e commissioni restano con Stripe.",
        already_connected: "Già connesso. Usa Modifica credenziali nell'elenco per sostituire la chiave.",
        already_connected_short: 'Già connesso.',
      },
      stripe_direct: {
        title: 'Stripe (diretto)',
        description: 'Addebita ogni ristorante tramite un tuo account Stripe unico.',
        unavailable: 'Non ancora disponibile nella tua regione.',
      },
      paypal: {
        direct: 'Offri PayPal dal tuo account business PayPal.',
        braintree: 'Accetta carte, PayPal e Venmo tramite il tuo account Braintree.',
      },
      other: {
        title: 'Altri fornitori',
        search: 'Cerca provider',
        loading: 'Caricamento provider…',
        no_match: 'Nessun provider chiamato “{{query}}”.',
        none_available: 'Nessun altro provider disponibile nella tua regione per ora.',
        load_error: "Impossibile caricare l'elenco dei provider.",
        retry: 'Riprova',
        pinned_match: 'Quel fornitore è fissato sopra.',
      },
      not_listed: {
        action: 'Il mio provider non è elencato',
        subject: 'Richiesta provider di pagamento: {{query}}',
      },
      use_foodamigos: {
        no_account: 'Non ho un account con nessuno di questi',
        switch: 'Passa ai pagamenti FoodAmigos',
      },
    },
    orchestrated: {
      title: 'Connetti {{name}}',
      replace_title: 'Sostituisci le credenziali per {{name}}',
      intro: 'Inserisci le credenziali del tuo account {{name}}. Le verifichiamo con {{name}} prima di salvare.',
      auth_mode: 'Come accedi a questo provider',
      checking: 'Verifica con {{name}}…',
      paypal_direct: {
        intro:
          "Incolla il Client ID e il Secret dell'app REST PayPal tramite cui i tuoi ristoranti devono accettare PayPal. Li verifichiamo con PayPal prima di salvare.",
        client_id: 'Client ID',
        secret: 'Secret',
        hint: "Dashboard sviluppatori PayPal → App e credenziali, nella scheda Live. Usa un'app REST del tuo account business.",
        hint_sandbox:
          'Dashboard sviluppatori PayPal → App e credenziali, nella scheda Sandbox: questo ambiente accetta solo app sandbox.',
      },
      braintree: {
        intro:
          'Inserisci le chiavi API del tuo account Braintree. PayPal e Venmo funzionano una volta collegati nel tuo Pannello di controllo Braintree — li attivi per connessione in seguito.',
      },
      authorize_net: {
        intro:
          "Inserisci l'API Login ID e la Transaction Key del tuo account Authorize.Net. Li verifichiamo con una piccola autorizzazione di prova: il registro transazioni di Authorize.Net la mostra come un $1,00 rifiutato, senza alcun movimento di denaro. L'account deve essere in modalità Live, perché in modalità Test Authorize.Net rifiuta ogni pagamento reale.",
        hint: "Trovi entrambi nell'interfaccia commerciante di Authorize.Net, in {{path}}.",
      },
      card_connect: {
        intro:
          "Inserisci l'ID esercente, il nome utente e la password del tuo account CardConnect (CardPointe) attivo. Li verifichiamo con un'autorizzazione di 1,00 che annulliamo subito: nel registro transazioni di CardPointe compare come 1,00 rifiutato o annullato, e non viene spostato denaro.",
      },
      stripe_direct: {
        intro:
          "Incolla la chiave segreta o una chiave con restrizioni dell'account Stripe attraverso cui ogni ristorante deve incassare. Configuriamo noi il webhook di cui Stripe ha bisogno.",
        secret_key: 'Chiave segreta o con restrizioni di Stripe',
        hint: 'Stripe → Developers → API keys. Inizia con sk_ (segreta) o rk_ (con restrizioni). Una chiave con restrizioni richiede accesso in scrittura a Charges and Refunds, Customers, PaymentIntents, PaymentMethods, SetupIntents, Tokens e Webhook Endpoints. Non serve alcuna chiave pubblicabile.',
        prefix_error: 'Le chiavi segrete di Stripe iniziano con sk_, quelle con restrizioni con rk_.',
      },
      connected: {
        title: '{{name}} è connesso.',
        description:
          'Useremo queste credenziali per tutti i tuoi ristoranti. Ogni ristorante aggiunge comunque i propri dati aziendali.',
      },
      errors: {
        generic: 'Non siamo riusciti a connettere {{name}}',
      },
    },
    stripe: {
      title: 'Collega Stripe Connect',
      rotate_title: 'Sostituisci la chiave Stripe Connect',
      rotate_intro:
        'Incolla una nuova chiave segreta e una chiave pubblicabile dello stesso account Stripe. I tuoi ristoranti restano connessi.',
      intro:
        'Incolla la chiave segreta e la chiave pubblicabile del tuo account Stripe. Entrambe si trovano in Developers → API keys.',
      verify_and_connect: 'Verifica e collega',
      checking: 'Verifica con Stripe…',
      secret_key: {
        label: 'Chiave segreta',
        hint: 'Stripe → Developers → API keys. Inizia con sk_.',
        prefix_error: 'Le chiavi segrete iniziano con sk_. Questa sembra un tipo diverso di chiave.',
      },
      restricted_key: {
        label: 'Chiave API con restrizioni',
        hint: 'Stripe → Sviluppatori → Chiavi API → Crea chiave limitata. Inizia con rk_. Configurala come descritto sopra.',
        prefix_error: 'Le chiavi con restrizioni iniziano con rk_. Questa sembra un tipo di chiave diverso.',
      },
      use_restricted_key: 'Usa invece una chiave con restrizioni',
      use_secret_key: 'Usa invece la chiave segreta',
      publishable_key: {
        label: 'Chiave pubblicabile',
        hint: 'Nella stessa pagina Stripe. Inizia con pk_. I tuoi negozi online ne hanno bisogno per accettare carte.',
        prefix_error: 'Le chiavi pubblicabili iniziano con pk_.',
        mode_mismatch: "Una chiave è live e l'altra è di test. Entrambe devono provenire dalla stessa modalità Stripe.",
      },
      name: {
        label: 'Nome di questa connessione',
        hint: 'Facoltativo. Mostrato ovunque questo fornitore sia elencato.',
        placeholder: 'Stripe Connect',
      },
      permissions: {
        title: 'Come creare questa chiave',
        start_blank:
          'Quando Stripe chiede come utilizzerai la chiave, scegli «{{option}}». Parte con ogni autorizzazione impostata su {{none}}.',
        intro:
          "Poi imposta l'interruttore su ciascuna di queste righe di sezione. Imposta tutti i permessi di quella sezione, quindi non serve passarli uno per uno.",
        rows_checked: 'Controlliamo: {{rows}}',
        secret_key_hint: 'Lascia ogni altra sezione su {{none}}. Una chiave segreta non ne ha bisogno.',
        open_stripe: 'Apri le tue chiavi API Stripe',
      },
      login_setting: {
        title: 'Disattiva l’accesso Stripe per i tuoi ristoranti',
        description:
          'Nella tua Dashboard Stripe, apri Impostazioni → Connect → Pagamenti → Conti esterni e disattiva “{{setting}}”. Finché è attivo, Stripe obbliga ogni ristorante a creare un accesso Stripe con un numero di telefono durante l’onboarding e chiede un codice SMS a ogni visita successiva, quindi chi non ha quel telefono non può continuare.',
        bank_details: 'Non si perde nulla: i ristoranti inseriscono le coordinate bancarie nel nostro modulo.',
        open_stripe: 'Apri questa impostazione di Stripe',
      },
      errors: {
        generic: 'Impossibile contattare Stripe',
      },
    },
    default_choice: {
      label: 'Usa come predefinito per i ristoranti',
      hint: 'I nuovi ristoranti e quelli che non hanno ancora un provider vengono collegati automaticamente. Lascia la casella deselezionata per scegliere tu un provider per ogni ristorante.',
    },
    manage: {
      payment_methods: 'Metodi di pagamento',
      edit_credentials: 'Modifica credenziali',
      edit_credentials_unavailable: 'Modifica credenziali (provider non disponibile al momento)',
      set_primary: 'Imposta come predefinito per i nuovi ristoranti',
      clear_primary: 'Non usare come predefinito per i nuovi ristoranti',
      rename: {
        action: 'Rinomina connessione',
        title: 'Rinomina questa connessione',
        confirm: 'Salva',
      },
      disconnect: {
        action: 'Disconnetti',
        title: 'Disconnettere {{name}}?',
        confirm: 'Disconnetti',
        warning_one: '{{count}} ristorante è collegato e tornerà a Non configurato.',
        warning_other: '{{count}} ristoranti sono collegati e torneranno a Non configurato.',
        live: {
          title_one: 'I pagamenti online si interrompono per {{count}} ristorante attivo',
          title_other: 'I pagamenti online si interrompono per {{count}} ristoranti attivi',
          description:
            'Appena scolleghi il provider, i clienti non potranno più pagare online. Ogni ristorante torna su Non configurato finché non lo colleghi a un altro provider.',
          refunds: 'Gli ordini già pagati tramite questo provider non possono più essere rimborsati da FoodAmigos.',
          pause_one: 'Sospendi i pagamenti online per questo ristorante',
          pause_other: 'Sospendi i pagamenti online per questi {{count}} ristoranti',
          confirm: 'Scollega e sospendi i pagamenti',
        },
      },
      remove: {
        action: "Rimuovi dall'elenco",
        title: 'Rimuovere {{name}}?',
        description: 'È già scollegato e nessun ristorante lo utilizza. Non verrà più mostrato in questo elenco.',
        confirm: 'Rimuovi',
      },
    },
    payment_methods: {
      title: 'Metodi di pagamento per {{name}}',
      description:
        'Scegli i metodi locali che i tuoi ristoranti offrono tramite questo provider. Ognuno appare solo dove la valuta del ristorante corrisponde.',
      save: 'Salva',
      publishable_key: {
        label: 'Chiave pubblicabile Stripe',
        hint: 'Stripe ne ha bisogno per mostrare il modulo di pagamento. La trovi nella tua Dashboard Stripe in Sviluppatori → Chiavi API.',
        invalid: 'Una chiave pubblicabile qui inizia con {{prefix}}.',
        clear_to_save:
          'Appartiene all’altra modalità di Stripe. Cancellalo per salvare con tutti i metodi locali disattivati.',
      },
      on_other_connection: 'già attivato per {{connection}}',
      other_currency: 'non disponibile in {{currency}}',
      delivery_only: "{{name}} (solo per ordini con consegna — richiede l'indirizzo del cliente)",
      invite_only:
        "{{name}} (Stripe lo offre solo su invito — richiedi prima l'accesso nella tua dashboard Stripe, altrimenti Stripe rifiuta ogni pagamento)",
      also_enable: {
        stripe:
          'Attiva gli stessi metodi nella tua Dashboard Stripe in Impostazioni → Metodi di pagamento, altrimenti Stripe li rifiuta.',
        provider: 'Il tuo contratto con questo provider deve includere i metodi che attivi qui.',
        braintree:
          'Collega prima PayPal e Venmo nel tuo Pannello di controllo Braintree in Impostazioni → Elaborazione, altrimenti Braintree li rifiuta. Venmo è per ristoranti USA che addebitano in dollari.',
        paypal_direct:
          'I pagamenti PayPal vengono accreditati su questo account business PayPal. Per Venmo, collega Braintree.',
      },
    },
    actions: {
      cancel: 'Annulla',
    },
    toasts: {
      load_error: 'Impossibile caricare i fornitori collegati',
      credentials_replaced: 'Credenziali sostituite',
      save_error: 'Salvataggio non riuscito',
      connected: 'Stripe Connect è collegato',
      renamed: 'Connessione rinominata',
      primary_set: 'Fornitore predefinito aggiornato',
      primary_cleared:
        'Provider predefinito rimosso. I nuovi ristoranti non sono collegati a nessun provider finché non ne selezioni uno.',
      disconnected: 'Fornitore disconnesso',
      removed: 'Provider rimosso',
      payment_methods_saved: 'Metodi di pagamento salvati',
    },
  },
  restaurants: {
    title: 'Ristoranti',
    description: 'A che punto è ogni ristorante con i pagamenti online.',
    search: 'Cerca ristoranti',
    filters: {
      all: 'Tutti ({{count}})',
      needs_attention: 'Richiede attenzione ({{count}})',
    },
    empty: 'Nessun ristorante ancora.',
    empty_attention: 'Nulla richiede la tua attenzione.',
    columns: {
      restaurant: 'Ristorante',
      provider: 'Fornitore',
      status: 'Stato',
      action: 'Azione',
    },
    no_provider: '—',
    foodamigos_payments: 'Pagamenti FoodAmigos',
    groups: {
      not_set_up: 'Non configurato',
      business_details_missing: 'Dati aziendali mancanti',
      hosted_not_finished: 'Modulo {{provider}} non completato',
      hosted_not_finished_generic: 'Modulo del fornitore non completato',
      waiting_for_provider: 'In attesa del fornitore',
      action_needed: 'Azione richiesta',
      payments_live: 'Pagamenti attivi',
      online_payments_off: 'Pagamenti online disattivati',
      waiting_for_partner: 'In attesa di te',
    },
    link_expired: 'Link scaduto',
    actions: {
      set_up: 'Configura',
      change: 'Cambia',
      unlink: 'Scollega',
      remind: 'Ricorda al proprietario',
      reminded: 'Ricordato · di nuovo {{time}}',
      start_over: 'Riavvia la configurazione di Stripe',
    },
    assign: {
      title: 'Quale fornitore dovrebbe usare {{name}}?',
      label: 'Fornitore',
      confirm: 'Salva',
      cancel: 'Annulla',
      primary: 'Predefinito',
      none: 'Collega prima un fornitore.',
    },
    unlink: {
      title: 'Scollegare {{name}} da {{provider}}?',
      title_generic: 'Scollegare {{name}} dal suo provider?',
      description:
        'Il ristorante torna a «Non configurato», così potrai scegliere il provider giusto per lui. Il provider resta collegato per gli altri tuoi ristoranti.',
      confirm: 'Scollega',
    },
    pause: {
      title: 'I pagamenti online per {{name}} vengono sospesi',
      description:
        'I suoi clienti non potranno più pagare online finché il ristorante non sarà configurato e verificato di nuovo con un provider.',
      refunds: 'Gli ordini già pagati tramite il provider attuale non potranno più essere rimborsati da FoodAmigos.',
      confirm: 'Sospendi i pagamenti online per questo ristorante',
    },
    start_over: {
      title: 'Riavviare la configurazione di Stripe di {{name}}?',
      points: {
        not_used: 'Il suo attuale account Stripe ({{account}}) non verrà più utilizzato per questo ristorante.',
        kept: "L'account non viene eliminato: resta nel tuo Stripe, dove puoi rifiutarlo.",
        fresh: "Il prossimo clic su «Continua» riparte dalla prima pagina di Stripe e si può usare un'email diversa.",
        paused:
          'Se il ristorante accetta pagamenti online, questi restano sospesi finché la nuova configurazione non è completata.',
      },
      confirm: 'Riavvia',
      blocked: {
        received_payments:
          "L'account Stripe di questo ristorante ha ricevuto pagamenti, quindi la configurazione non può essere riavviata. Contatta l'assistenza per modificarla.",
        partner_action_needed: 'Risolvi prima il problema indicato nel tuo Stripe Connect.',
      },
    },
    toasts: {
      load_error: 'Impossibile caricare i tuoi ristoranti',
      assigned: 'Fornitore salvato',
      assign_error: 'Impossibile salvare il fornitore',
      unlinked: 'Ristorante scollegato',
      unlink_error: 'Impossibile scollegare il ristorante',
      reminded: 'Promemoria inviato al proprietario',
      remind_error: 'Impossibile inviare il promemoria',
      cooling_down: 'Il proprietario è già stato avvisato oggi',
      started_over: 'Configurazione di Stripe riavviata',
      start_over_error: 'Impossibile riavviare la configurazione di Stripe',
    },
  },
  footer: {
    text: 'La tua commissione di servizio FoodAmigos ti viene fatturata indipendentemente dal fornitore usato dal ristorante.',
    link: 'Vedi Fatturazione',
  },
};
